import { apiFetch } from './apiFetch';

/**
 * A photo this browser kept before profile photos were stored on the server
 * (users.photo_url, 2026-10-27). Profile settings moves it there once, then
 * removes it; nothing else reads it.
 */
export function loadProfilePhoto(userId?: string | null) {
  if (!userId) return '';
  try {
    return localStorage.getItem(`tinycms.profilePhoto.${userId}`) || '';
  } catch {
    return '';
  }
}

const IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];

/** Upload the file to the person's own media folder; the address comes back, to save on the profile. */
export async function uploadProfilePhoto(file: File): Promise<string> {
  if (!IMAGE_TYPES.includes(file.type)) {
    throw new Error('Choose a JPEG, PNG, GIF, or WebP image.');
  }
  const body = new FormData();
  body.append('file', file);
  const response = await apiFetch('/api/upload/media', {
    method: 'POST',
    body,
  });
  const result = (await response.json().catch(() => ({}))) as { url?: string; error?: string };
  if (!response.ok || !result.url) {
    throw new Error(result.error || 'Could not save that photo.');
  }
  return result.url;
}
